import { ROUTES } from "@/constants/routes";
import ForgotPasswordPage from "@/features/auth/pages/ForgotPasswordPage";
import LinkSentPage from "@/features/auth/pages/LinkSentPage";
import LoginPage from "@/features/auth/pages/LoginPage";
import SetPasswordPage from "@/features/auth/pages/SetPasswordPage";
import SignOutPage from "@/features/auth/pages/SignOutPage";
import { RouteConfig } from "@/types/route-types";

// Auth routes configuration
export const AUTH_ROUTES: RouteConfig[] = [
  { path: ROUTES.login, element: LoginPage },
  { path: ROUTES.signOut, element: SignOutPage },
  { path: ROUTES.forgotPassword, element: ForgotPasswordPage },
  { path: ROUTES.changePassword, element: SetPasswordPage },
  { path: ROUTES.setPassword, element: SetPasswordPage },
  { path: ROUTES.linkSent, element: LinkSentPage },
] as const;
